<div class="container">
  <h1 i18n>Preguntas Frecuentes</h1>
  <hr/>
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="pb-5">
        <faq [faqs]='faqList' [sliceItems]="this.sliceItems"></faq>
      </div>
    </div>
  </div>
</div>